import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function libraryDocumentsReducer(state = initialState, action) {
  switch (action.type) {
    case types.LIBRARY_DOCUMENTS_INIT:
      return { ...state, error: null, isLoading: true };

    case types.LIBRARY_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: action.data.data,
        error: action.data.error,
      };

    case types.LIBRARY_DOCUMENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
